import { render, staticRenderFns } from "./tournament-registration.vue?vue&type=template&id=1a86ca29&scoped=true&"
import script from "./tournament-registration.vue?vue&type=script&lang=js&"
export * from "./tournament-registration.vue?vue&type=script&lang=js&"
import style0 from "./tournament-registration.vue?vue&type=style&index=0&id=1a86ca29&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a86ca29",
  null
  
)

export default component.exports